import getters from './getters'
import { actions as actions } from './actions'
import { mutations } from './mutations'

const state = {
  shops: {
    loading: true,
    data: null,
    error: false
  },
  shopsSearched: {
    loading: true,
    data: null,
    error: false
  },
  current: {
    loading: true,
    data: {
      oid: null,
      name: '',
      category: '',
      registeredUser: null,
      isOpen: null,
      position: {
        lat: 0,
        lng: 0
      },      
    },
    error: false  
  },
  products: {},
  services: null,
  productsfilterSelected: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/shops/index.js
// module id = null
// module chunks = 